// Options for the one mixpanel.init call in App.jsx.
//
// The iOS build sets REACT_APP_QLEARN_DISABLE_THIRD_PARTY_TRACKING=true (see
// services/mobileAnalyticsClient.js). There Mixpanel is opted out by default,
// so track, identify and people.set return before anything is sent, and
// request batching is off: mixpanel-browser 2.45 flushes a batch queue left in
// localStorage during init, before it applies the opt-out, and the batcher's
// flush never checks it. Web leaves the flag unset and gets {} — the same as
// the bare mixpanel.init(key) it had before.
//
// The opt-out is saved on the device. If iOS ever turns Mixpanel back on, the
// app must call mixpanel.opt_in_tracking() as well as change these options.
// Never call mixpanel.opt_out_tracking() on iOS without { delete_user: false }:
// after identify() it sends a people delete request, which skips the opt-out.
export const mixpanelInitOptions = (
  thirdPartyTrackingDisabled = process.env.REACT_APP_QLEARN_DISABLE_THIRD_PARTY_TRACKING === 'true'
) => (thirdPartyTrackingDisabled
  ? { opt_out_tracking_by_default: true, batch_requests: false }
  : {});
